import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_uLearn/layout/core';
// import AllActivity from './all-activity-configuration';
import { lazy } from 'react';
const AllActivity = lazy(() => import('./all-activity-configuration'));
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Profile',
    path: 'activity-configuration',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route
        path="*"
        element={<Navigate to="/error/404" />}
      />
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>
              Activity Configuration
            </PageTitle>
            <AllActivity />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
